<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-6"><a href="#/OEBPS/Burgundy_Twisted_Roots2#Contents-A">Epigraph</a></p>
<p class="body-center1">“Those cries rose from among the twisted roots <br class="calibre1"/>through which the spirit of the damned <br class="calibre1"/>were slinking to hide from us….”</p>
<p class="body-center2"><em class="italic">—Dante Alighieu</em></p>
<p class="heading"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Burgundy_Twisted_Roots5.vue?2fc06633